import chroma from 'chroma-js';
import {AlignControlValue, Style} from 'common/constants/survey';

const {
    routes: {staticPath},
} = window.YC;

const colorPattern = '^#[a-z0-9]{6}$';

// source https://gist.github.com/dperini/729294
const urlPattern =
    '^' +
    // for less url must be in quotation marks
    '["]*' +
    // protocol identifier (optional)
    // short syntax // still required
    '(?:(?:(?:https?|ftp):)?\\/\\/)' +
    // user:pass BasicAuth (optional)
    '(?:\\S+(?::\\S*)?@)?' +
    '(?:' +
    // IP address exclusion
    // private & local networks
    '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
    '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
    '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
    // IP address dotted notation octets
    // excludes loopback network 0.0.0.0
    // excludes reserved space >= 224.0.0.0
    // excludes network & broadcast addresses
    // (first & last IP address of each class)
    '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
    '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
    '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
    '|' +
    // host & domain names, may end with dot
    // can be replaced by a shortest alternative
    // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
    '(?:' +
    '(?:' +
    '[a-z0-9\\u00a1-\\uffff]' +
    '[a-z0-9\\u00a1-\\uffff_-]{0,62}' +
    ')?' +
    '[a-z0-9\\u00a1-\\uffff]\\.' +
    ')+' +
    // TLD identifier name, may end with dot
    '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
    ')' +
    // port number (optional)
    '(?::\\d{2,5})?' +
    // resource path (optional)
    '(?:[/?#]\\S*)?' +
    '$';

const linearGradientPattern = '^\\w+-gradient\\(.*?\\)\\)|\\w+-gradient\\(.*?\\)$';

export const validationSchema = {
    type: 'object',
    properties: {
        bg_url: {
            type: 'string',
            pattern: urlPattern,
        },
        page_bg_url: {
            type: 'string',
            pattern: urlPattern,
        },
        answer_text_color: {
            type: 'string',
            pattern: colorPattern,
        },
        add_pad: {
            type: 'string',
            pattern: '^(true|false)$',
        },
        align_controls: {
            type: 'string',
            pattern: '^(center|right|left)$',
        },
        button_border_radius: {
            type: 'integer',
            minimum: 0,
            maximum: 32,
        },
        control_opacity: {
            type: 'number',
            minimum: 0,
            maximum: 1,
        },
        controls_color: {
            type: 'string',
            pattern: colorPattern,
        },
        font_family: {
            type: 'string',
            pattern: '^[a-zA-Z,"\\- ]+$',
        },
        form_border_radius: {
            type: 'integer',
            minimum: 0,
            maximum: 32,
        },
        form_opacity: {
            type: 'number',
            minimum: 0,
            maximum: 1,
        },
        form_padding: {
            type: 'integer',
            minimum: 0,
            maximum: 32,
        },
        question_text_color: {
            type: 'string',
            pattern: colorPattern,
        },
        page_title_color: {
            type: 'string',
            pattern: colorPattern,
        },
        bg_color: {
            type: 'string',
            pattern: colorPattern,
        },
        page_bg_color: {
            type: 'string',
            pattern: colorPattern,
        },
        body_padding: {
            type: 'integer',
            minimum: 0,
            maximum: 32,
        },
        bg_gradient: {
            type: 'string',
            pattern: linearGradientPattern,
        },
    },
};

export const alignToFlexMap = {
    [AlignControlValue.Left]: 'start',
    [AlignControlValue.Center]: 'center',
    [AlignControlValue.Right]: 'end',
};

export const MIN_CONTRAST_RATIO = 5;
export const WHITE = chroma('white');
export const GRAY = chroma('lightgray');
export const BLACK = chroma('black');

export const defaultStyles = {
    [Style.PageBackgroundUrl]: 'none',
    [Style.PageBackgroundColor]: '#ffffff',
    [Style.PageTitleColor]: '#000000',

    [Style.BackgroundUrl]: 'none',
    [Style.BackgroundColor]: '#ffffff',
    [Style.BodyPadding]: 0,

    [Style.FormPadding]: 32,
    [Style.FormOpacity]: 1,
    [Style.FormBorderRadius]: 12,

    [Style.AnswerTextColor]: '#000000',
    [Style.QuestionTextColor]: '#000000',

    [Style.ControlOpacity]: 0,
    [Style.ButtonBorderRadius]: 8,
    [Style.ControlsColor]: '#5282ff',

    [Style.AlignControls]: AlignControlValue.Left,
    [Style.FontFamily]: 'default',
};

export const imagePath = staticPath + '/public/styles_templates_images';
